import { Label } from '@firmable/common';
import clsx from 'clsx';
import { InputHTMLAttributes } from 'react';
import type { FieldError, FieldValues, Path, RegisterOptions, UseFormRegister } from 'react-hook-form';
import { usePlaceholderLabel } from '../utilities/usePlaceholderLabel';
export interface InputProps<FormFieldValues extends FieldValues> extends InputHTMLAttributes<HTMLInputElement> {
  name: Path<FormFieldValues>;
  register: UseFormRegister<FormFieldValues>;
  options?: RegisterOptions;
  error?: FieldError;
}

export const Input = <FormFieldValues extends Record<string, unknown>>({
  error,
  type = 'text',
  name,
  register,
  options,
  className,
  ...rest
}: InputProps<FormFieldValues>) => {
  const { ref: labelRef, ariaLabel } = usePlaceholderLabel<HTMLInputElement>(rest);
  const { ref: registerRef, ...registered } = register(name, options);
  return (
    <>
      <input
        className={clsx(
          'p-sm h-10 border border-solid rounded-radius-md w-full bg-surface-white border-stroke-light text-content-dark text-body-large transition-colors hover:border-stroke-dark focus:ring-1 focus:ring-stroke-interactive focus:border-stroke-interactive focus:outline-none disabled:cursor-not-allowed disabled:opacity-50 disabled:hover:border-stroke-light',
          className,
        )}
        type={type}
        autoComplete="off"
        aria-autocomplete="none"
        spellCheck={false}
        {...rest}
        aria-label={ariaLabel}
        {...registered}
        ref={(node) => {
          labelRef.current = node;
          registerRef(node);
        }}
      />
      {!!error && <Label.Error data-elements={error.message}>{error.message}</Label.Error>}
    </>
  );
};
